import {
  INCIDENT_DETAILS_REQUESTED,
  INCIDENT_DETAILS_PROCESSING,
  INCIDENT_DETAILS_SUCCESSED,
  INCIDENT_DETAILS_FAILED,
  INCIDENT_DETAILS_UPDATE,
} from '../../constants/actionTypes';

const initialState = {
  listData: {},
  isProcessing: false,
  isSuccess: null,
  hasErrors: null,
};

export const incidentDetails = (state = initialState, action) => {
  switch (action.type) {
    case INCIDENT_DETAILS_REQUESTED: {
      return {
        ...state,
        listData: null,
        hasErrors: null,
        isProcessing: true,
        isSuccess: null,
      };
    }
    case INCIDENT_DETAILS_PROCESSING: {
      return {
        ...state,
        listData: null,
        hasErrors: null,
        isProcessing: true,
        isSuccess: null,
      };
    }
    case INCIDENT_DETAILS_SUCCESSED: {
      return {
        listData: action.data,
        hasErrors: null,
        isProcessing: false,
        isSuccess: true,
      };
    }
    case INCIDENT_DETAILS_FAILED: {
      return {
        listData: action.data,
        hasErrors: true,
        isProcessing: false,
        isSuccess: null,
      };
    }
    case INCIDENT_DETAILS_UPDATE: {
      return {
        ...state,
        listData: {
          ...state.listData,
          data: action?.payload
        },
        hasErrors: null,
        isProcessing: false,
        isSuccess: true,
      };
    }
    default: {
      return {
        ...state,
      };
    }
  }
};

export default incidentDetails;
